import { ReactNode } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import styled, { css } from "styled-components";
import { useNavigate } from "react-router";
import { HStack, VCenter } from "../../../../shared/src/Components/Stacks.ts";

const Container = styled.div`
    display: flex;
    width: 100%;
    flex-shrink: 0;
    flex-direction: row;
    position: relative;
    justify-content: space-between;
    height: 1rem;
`;

type GoBack = {
    noBackButton?: boolean;
};

const GoBack = styled.button<GoBack>`
    z-index: 898;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;

    ${(props) =>
        props.noBackButton &&
        css`
            visibility: hidden;
        `}

    top: 0;
    bottom: 0;

    width: 25px;
    transition:
        transform var(--duration) ease-in-out,
        filter var(--duration) ease-in-out,
        box-shadow var(--duration) ease-in-out;

    &:hover,
    &:focus {
        transform: translate(-1.5px, -1.5px);
        filter: drop-shadow(1.5px 1.5px var(--accent-shadow));
    }

    @keyframes wiggle {
        0% {
            transform: rotate(-5deg);
            animation-timing-function: ease-in;
        }

        50% {
            transform: rotate(7.5deg);
            animation-timing-function: ease-out;
        }
    }

    &:active {
        color: var(--accent);
        transform: translate(0, 0);
        filter: none;
        animation-delay: 0.2s;
        animation-name: wiggle;
        animation-duration: 0.25s;
        animation-iteration-count: infinite;
        animation-direction: alternate;
    }
`;

const Icon = styled(GoBack)`
    position: relative;
`;

const Title = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1rem;
    width: 100%;
    text-align: center;
`;

const RTL = styled.div`
    display: contents;

    html[dir="rtl"] & {
        transform: scaleX(-1);
    }
`;

function Header({
    title,
    children,
    onBack,
    noBackButton,
    icon,
    onIcon,
}: {
    title?: string | ReactNode;
    children?: ReactNode;
    onBack?: () => void | Promise<void>;
    onIcon?: () => void | Promise<void>;
    noBackButton?: boolean;
    icon?: JSX.Element;
}) {
    const navigate = useNavigate();

    return (
        <>
            <Container>
                <GoBack noBackButton={noBackButton} onClick={() => (onBack ? onBack() : navigate(-1))}>
                    <RTL>
                        <FaArrowLeftLong size={20} />
                    </RTL>
                </GoBack>

                {title ? (
                    <Title>{title}</Title>
                ) : (
                    <VCenter no_horizontal_center={true}>
                        <HStack gap={"6"}>{children}</HStack>
                    </VCenter>
                )}
                {icon && (
                    <Icon onClick={onIcon}>
                        <RTL>{icon}</RTL>
                    </Icon>
                )}
            </Container>
        </>
    );
}

export default Header;
